import { render, staticRenderFns } from "./Attachement.vue?vue&type=template&id=d38b1796&scoped=true"
import script from "./Attachement.vue?vue&type=script&lang=js"
export * from "./Attachement.vue?vue&type=script&lang=js"
import style0 from "./Attachement.vue?vue&type=style&index=0&id=d38b1796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38b1796",
  null
  
)

export default component.exports